import * as React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Form, FormitConsumer, Field } from '@oakwood/formit'
import Alert from '@material-ui/lab/Alert'
import { useTranslations } from 'containers/Translations/TranslationsContext'
import Checkbox from 'components/Checkbox'
import FormControlLabel from 'components/FormControlLabel'
import Link from 'components/Link'
import LoadingButton from 'components/LoadingButton'
import Typography from 'components/Typography'
import { useAuth } from '../AuthContext'
import AuthCommonFields from './AuthCommonFields'

export const useStyles = makeStyles((theme) => ({
  header: {},
  main: {},
  footer: {},
  submitButton: theme.mixins.inputMargin('normal'),
  secondaryAction: {
    margin: theme.spacing(1),
    textAlign: 'center',
  },
  alert: { marginTop: theme.spacing(1) },
}))

function AuthLogin(props) {
  const classes = useStyles(props)
  const { onLoginOrRegisterScreenToggle, onRecoverPasswordScreenOpen, formitError } = useAuth()

  const t = useTranslations()

  return (
    <>
      <div className={classes.header}>
        <Typography component="h1" variant="h5">
          {t('Web.AuthLoginEmail.SignIn')}
        </Typography>
      </div>

      <Form className={classes.main}>
        <AuthCommonFields />

        <Field
          component={FormControlLabel}
          control={<Checkbox />}
          label={t('Web.AuthLoginEmail.RememberMe')}
          name="rememberMe"
        />

        <FormitConsumer>
          {({ isSubmitting }) => (
            <LoadingButton
              className={classes.submitButton}
              pending={isSubmitting}
              variant="outlined"
              type="submit"
              fullWidth
            >
              {t('Web.AuthLoginEmail.SignIn.Button')}
            </LoadingButton>
          )}
        </FormitConsumer>

        {formitError && (
          <Alert className={classes.alert} severity="error">
            {t('Web.Authentication.InvalidCredentials')}
          </Alert>
        )}

        <div className={classes.secondaryAction}>
          <Link // eslint-disable-line jsx-a11y/anchor-is-valid
            onClick={onRecoverPasswordScreenOpen}
            component="button"
            type="button"
            underline="always"
            variant="body1"
          >
            {t('Web.AuthLoginEmail.ForgotPassword')}
          </Link>
        </div>
      </Form>

      <div className={classes.footer}>
        <Typography>{t('Web.AuthLoginEmail.NoAccount')}</Typography>

        <Link // eslint-disable-line jsx-a11y/anchor-is-valid
          onClick={onLoginOrRegisterScreenToggle}
          component="button"
          type="button"
          underline="always"
          variant="body1"
        >
          {t('Web.AuthLoginEmail.SignUp')}
        </Link>
      </div>
    </>
  )
}

export default AuthLogin
